import { Accordion, Anchor, Box, Card, Paragraph, Text } from '@zillow/constellation-10';

import StringConstants from '@common/constants/StringConstants';
import { FaqModel } from '@common/types';

const supportEmail = StringConstants.LINKS.SUPPORT_EMAIL.zillow;
const faqLink = `${StringConstants.LINKS.FAQ_PAGE.zrm}?utm_campaign=landlord_payments_faq`;

interface IFaqComponentProps {
  faqs?: FaqModel[];
  title?: string;
  showContactSection?: boolean;
  withBorder?: boolean;
  onFAQClick?: () => any;
  actionButton?: JSX.Element;
}

const FaqComponent = ({
  faqs,
  title = 'Frequently asked questions',
  showContactSection = true,
  withBorder = true,
  onFAQClick,
  actionButton,
}: IFaqComponentProps) => {
  const renderFaqRow = ({ question, answer }, i) => {
    return (
      <Accordion.Item value={`accordion-${i}`} key={`accordion-${i}`}>
        <Accordion.Header css={{ padding: '12px 16px !important' }}>
          <Paragraph>{question}</Paragraph>
        </Accordion.Header>
        <Accordion.Panel css={{ padding: '12px 16px !important' }}>
          <Paragraph>{answer}</Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
    );
  };

  const renderBody = () => (
    <>
      {title && (
        <Paragraph textStyle="body-bold" css={{ marginBottom: 'token(spacing.sm) !important' }}>
          {title}
        </Paragraph>
      )}
      {faqs && (
        <Accordion.Root
          type="single"
          onExpandedChange={(expanded) => {
            if (expanded.length && onFAQClick) {
              onFAQClick();
            }
          }}
        >
          {faqs.map(({ question, answer }, i) =>
            renderFaqRow(
              {
                question,
                answer,
              },
              i,
            ),
          )}
        </Accordion.Root>
      )}
      {showContactSection && (
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'token(spacing.md)',
            marginTop: 'token(spacing.md) !important',
          }}
        >
          <Text textStyle="body-sm">
            Visit our{' '}
            <Anchor href={faqLink} target="_blank">
              FAQ page
            </Anchor>{' '}
            for other common payments questions. Still have questions?{' '}
            <Anchor href={`mailto:${supportEmail}`}>Email us</Anchor>
          </Text>
        </Box>
      )}
      {actionButton && <Box css={{ marginTop: 'token(spacing.md) !important' }}>{actionButton}</Box>}
    </>
  );
  return withBorder ? (
    <Card
      elevated={false}
      css={{
        padding: 'token(spacing.md) !important',
        height: 'fit-content',
      }}
    >
      {renderBody()}
    </Card>
  ) : (
    renderBody()
  );
};

export default FaqComponent;
